import type { FC } from 'react';
import { cn } from 'src/utils/cn';

type SeparatorProps = {
  error?: boolean;
  disabled?: boolean;
};

export const Separator: FC<SeparatorProps> = (props) => {
  return (
    <div
      className={cn(
        'h-[130%] w-px bg-foreground-surface-default',

        props.error && 'bg-foreground-support-error',
        props.disabled && 'bg-foreground-surface-disabled'
      )}
    />
  );
};
